import React from "react";
import {useSelector} from "react-redux";
import {injectIntl} from "react-intl";
import classNames from "classnames/bind";
import {VOICE_CHAT_TYPE} from "utils/constants";
import User from "../User";
import styles from "./index.module.scss";

const UserList = ({
  intl,
  voiceChatType,
  volumeData,
  userList,
  privateChatStatus,
  getUserAttributes,
  sendCall,
  onClickLeaveChat,
  onClickEnterChat,
  currentChatMode,
}) => {
  const cn = classNames.bind(styles);
  const userInfo = useSelector(state => state.userinfo);
  const isWorldTab = voiceChatType === VOICE_CHAT_TYPE[0];
  const uid = new Buffer.from(String(userInfo.id)).toString("base64");
  return (
    <div className={cn("voice_chat_user_list")}>
      {isWorldTab && currentChatMode !== VOICE_CHAT_TYPE[0] && (
        <p className={cn("placeholder")}>
          {intl.formatMessage({id: "ID_VOICE_CHAT_LIST_PLACEHOLDER_WORLD"})}
        </p>
      )}
      {isWorldTab && currentChatMode === VOICE_CHAT_TYPE[0] && (
        <User
          user={userInfo}
          isMine={true}
          isWorldTab={isWorldTab}
          volumeData={volumeData}
          voiceChatType={voiceChatType}
        />
      )}
      {userList?.map(user => (
        <User
          key={user.id || user.uid}
          user={user}
          volumeData={volumeData}
          isMine={uid === user.uid}
          isWorldTab={isWorldTab}
          voiceChatType={voiceChatType}
          privateChatStatus={privateChatStatus}
          micStatus={user.hasAudio}
          getUserAttributes={getUserAttributes}
          sendCall={sendCall}
          onClickLeaveChat={onClickLeaveChat}
          onClickEnterChat={onClickEnterChat}
          currentChatMode={currentChatMode}
        />
      ))}
    </div>
  );
};

export default injectIntl(UserList);
